import { useTransitions } from './useTransitions';
import { WrapperStyled, TextStyled } from './styled';

type AnimatedTextProps = {
  list: Array<{
    title?: string;
    text?: string;
  }>;
  totalDurationInSeconds: number;
  className?: string;
};

export const AnimatedText = ({ list, totalDurationInSeconds, className }: AnimatedTextProps) => {
  const { isVisible, currentMessageIndex } = useTransitions({
    itemsCount: list.length,
    totalDurationInSeconds,
  });

  return (
    <WrapperStyled className={className}>
      <TextStyled variant="h4" isVisible={isVisible}>
        {list[currentMessageIndex].title}
      </TextStyled>
      <TextStyled variant="bodyMediumSemiBold" isVisible={isVisible}>
        {list[currentMessageIndex].text}
      </TextStyled>
    </WrapperStyled>
  );
};
